<span
  *ngIf="ratingValue"
  class="badge rounded-pill"
  data-automation-id="score"
  [ngClass]="[size, colorClass, rootCssClass]"
>
  <i class="f-i f-i-replace" *ngIf="isCustomRating"></i>{{ localizedValue }}
</span>
